import { getCookie, removeCookie } from 'helpers/VanillaCookie';

/**
 * @returns {null|object}
 */
export function getMVPDAuthZObj() {
    const cookie = getCookie('mvpd_authz');
    try {
        let tokenObj = JSON.parse(cookie);

        if (tokenObj && typeof tokenObj === 'object') {
            return tokenObj;
        }
    } catch (e) {}

    return null;
}

export function getMVPDName() {
    try {
        let mvpdAuthz = getCookie('mvpd_authz');
        if (mvpdAuthz) {
            let mvpd = JSON.parse(mvpdAuthz);
            if (mvpd.mvpd_name && mvpd.mvpd_name.length > 1) {
                return mvpd.mvpd_name;
            }
        }
    } catch (e) {}

    return '';
}

/**
 * @returns {null|object}
 */
export function getMVPDCMObj() {
    const localStorageData = localStorage.getItem('mvpd_cm');

    try {
        let mvpd_cm = JSON.parse(localStorageData);

        if (mvpd_cm && typeof mvpd_cm === 'object') {
            return mvpd_cm;
        }
    } catch (e) {}

    return null;
}

/**
 * @returns {boolean}
 */
export function isMVPDComcast() {
    const IDP_COMCAST = 'Comcast_SSO';
    const mvpdAuthZ = getMVPDAuthZObj();

    return Boolean(mvpdAuthZ) && mvpdAuthZ.mvpd_name === IDP_COMCAST;
}

export function setMVPDConfigs(mvpdConfigList) {
    window.localStorage.setItem('mvpd_configs', JSON.stringify(mvpdConfigList));
}

/**
 * @param mvpd_name
 * @returns {null|*}
 */
export function getMVPDConfig(mvpd_name) {
    try {
        const mvpd_configs = JSON.parse(window.localStorage.getItem('mvpd_configs'));

        if (Array.isArray(mvpd_configs)) {
            let config = mvpd_configs.find((item) => {
                return mvpd_name.indexOf(item.adobe_id) > -1;
            });

            if (config && typeof config === 'object') {
                return config;
            }
        }
    } catch (e) {
        console.error('Error: ', e);
    }

    return null;
}

const mvpd_options_allowed = ['ENABLE_CONCURRENCY_MONITORING', 'ENABLE_CM_VOD', 'ENABLE_CM_LIVE'];
Object.freeze(mvpd_options_allowed);

/**
 * @returns {Array|null}
 */
export function mvpdOptions() {
    try {
        let cookie = getCookie('mvpd_authz');
        if (cookie) {
            let mvpd_options = JSON.parse(decodeURIComponent(cookie))['mvpd_options'];

            if (Array.isArray(mvpd_options)) {
                return mvpd_options;
            }
        }
    } catch (e) {
        console.error('Error: ', e);
    }
    return null;
}

/**
 * @param options = []
 * @returns {boolean}
 */
export function enableCMLiveTV(options = []) {
    if (!options || options.length === 0) {
        return false;
    }
    return options.includes(mvpd_options_allowed[2]) && options.includes(mvpd_options_allowed[0]);
}

/**
 * @param options = []
 * @returns {boolean}
 */
export function enableCMVOD(options = []) {
    if (!options || options.length === 0) {
        return false;
    }
    return options.includes(mvpd_options_allowed[1]) && options.includes(mvpd_options_allowed[0]);
}

/**
 * @param options = []
 * @returns {boolean}
 */
export function isConcurrencyMonitoringRequired(options = []) {
    if (!options || options.length === 0) {
        return false;
    }
    return options.includes(mvpd_options_allowed[0]);
}

/**
 * Setting this data for registering Continuous Monitoring and for storing householdID
 * @param key
 * @param data
 */
export const setMetaDataStatus = (key, data) => {
    let mvpd_cm = window.localStorage.getItem('mvpd_cm')
        ? JSON.parse(window.localStorage.getItem('mvpd_cm'))
        : {};

    if (key === 'mvpd') {
        mvpd_cm.idp = data;
    } else if (key === 'hba_status') {
        mvpd_cm.hba_status = data !== null ? data : false;
    } else if (key === 'upstreamUserID') {
        mvpd_cm.subject = data;
    } else if (key === 'householdID') {
        mvpd_cm.householdID = data;
    }
    window.localStorage.setItem('mvpd_cm', JSON.stringify(mvpd_cm));
};

export function cleanMVPD() {
    clearAuthsuiteStorage();
    window.localStorage.removeItem('mvpd_authz');
    window.localStorage.removeItem('mvpd_chosen_obj');
    window.localStorage.removeItem('mvpd_cm');
    window.localStorage.removeItem('mvpd_configs');
    removeCookie('mvpd_authz');
    window.localStorage.setItem('cbs_logout', new Date().toDateString());
    $.cookie('mvpd_authz', '', { path: '/', domain: '.cbs.com' });
}

export function clearAuthsuiteStorage() {
    window.localStorage.removeItem('auth-suite-applicationAccessToken');
    window.localStorage.removeItem('auth-suite-deviceRefreshToken');
}

export function parseAuthsuiteAccessToken() {
    const authSuiteAccessToken = window.localStorage.getItem('auth-suite-applicationAccessToken');

    if (authSuiteAccessToken) {
        var base64Url = authSuiteAccessToken.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join(''),
        );

        return JSON.parse(jsonPayload);
    } else {
        return false;
    }
}
